/**
 * BrandLogo — the hyggebam mark: two people on a couch around a play button.
 * Drawn in `currentColor` so it inherits the top bar's ink colour (white-ish)
 * and adapts to any theme. The "screen" is a recess (bg shows through) with a
 * solid play triangle inside, mirroring the original logo.
 */
export function BrandLogo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 120 86"
      fill="currentColor"
      role="img"
      aria-label="hyggebam"
    >
      <defs>
        <mask id="hb-screen">
          <rect width="120" height="86" fill="white" />
          {/* screen recess — bg shows through */}
          <rect x="44" y="34" width="32" height="28" rx="7" fill="black" />
          {/* play triangle stays solid inside the recess */}
          <path d="M55 41 L71 48 L55 55 Z" fill="white" />
        </mask>
      </defs>
      {/* two heads */}
      <circle cx="47" cy="18" r="15" />
      <circle cx="73" cy="18" r="15" />
      {/* couch (with the play screen masked out of it) */}
      <path
        mask="url(#hb-screen)"
        d="M24 74
           Q13 74 13 63
           L13 56
           Q13 46 24 46
           L24 44
           Q24 31 38 31
           L82 31
           Q96 31 96 44
           L96 46
           Q107 46 107 56
           L107 63
           Q107 74 96 74
           Z"
      />
    </svg>
  );
}
